import {Component, Input, OnInit} from '@angular/core';
import {AlertController, LoadingController, ModalController, ToastController} from '@ionic/angular';
import {RandomColors} from '../../definitions/random-colors';
import {DetaillineDTOModel} from '../../models/detaillineDTO.model';
import {LokijsService} from '../../services/database/lokijs.service';
import {DocumentModel} from '../../models/document.model';
import {HaccessModel} from '../../models/haccess.model';
import {AddAccessoriesPage} from '../add-accessories/add-accessories.page';
import {SaccessModel} from '../../models/saccess.model';
import {FindEquipmentPriceService} from '../../services/find-equipment-price.service';
import {ChargeLineDTOModel} from '../../models/charge-lineDTO.model';
import {BarcodeScanner} from '@ionic-native/barcode-scanner/ngx';
import {GeneralService} from '../../services/general.service';
import {RefreshdatabaseService} from '../../services/database/refreshdatabase.service';
import {BarcodescannerComponent} from '../barcodescanner/barcodescanner.component';
import {ScanBarcodeService} from '../../services/scan-barcode.service';
import {ConfigurationModel} from '../../models/configuration.model';
import {ConfigurationService} from '../../services/configuration.service';
import {TestConnectionService} from '../../services/test-connection.service';
import {GenerateDateFromTimestampService} from '../../services/generate-date-from-timestamp.service';
import {SysConfigModel} from '../../models/sys-config.model';
import {FindSystemConfigService} from '../../services/find-system-config.service';
import {DocumentTypes} from '../../definitions/document-types';
import {MobileConfigurationModel} from '../../models/mobile-configuration.model';
import {AndroidPermissions} from '@ionic-native/android-permissions/ngx';
import {PicturesPermissionService} from '../../services/pictures-permission.service';

@Component({
    selector: 'app-equipment-select',
    templateUrl: './equipment-select.html',
    styleUrls: ['./equipment-select.scss'],
})
export class EquipmentSelect implements OnInit {

    @Input() document: DocumentModel;
    @Input() detailLine: DetaillineDTOModel;
    pdescAccessories: HaccessModel[];
    pluAccessories: SaccessModel[];
    equipment: DetaillineDTOModel;
    accessoriesTemp: any[];
    level = 0;
    queryText = '';
    equipQty = 1;
    deptList: any[];
    groupList: any[];
    equipList: DetaillineDTOModel[];
    fromDate: string;
    toDate: string;
    comment = '';
    weeklyRate;
    discount;
    total;
    chargeLine: ChargeLineDTOModel;
    editItem;
    canUserEdit: boolean;
    equipmentDescription: string;
    configuration: ConfigurationModel;
    overbookingAllowed: SysConfigModel;
    overrideDescriptionAllowed: SysConfigModel;
    lastUpdate: string;
    loadingOverlay: any;
    mobileConfiguration: MobileConfigurationModel;
    @Input() replacementItem: Boolean

    constructor(private modalController: ModalController,
                private randomColors: RandomColors,
                private lokiJs: LokijsService,
                private toastController: ToastController,
                private alertController: AlertController,
                private loadingController: LoadingController,
                private findEquipmentPriceService: FindEquipmentPriceService,
                private androidPermissions: AndroidPermissions,
                private barcodeScanner: BarcodeScanner,
                private generalServices: GeneralService,
                private refreshDB: RefreshdatabaseService,
                private scanBarcodeService: ScanBarcodeService,
                private configurationService: ConfigurationService,
                private testConnection: TestConnectionService,
                private generateDateFromTimestamp: GenerateDateFromTimestampService,
                private findSysConfigService: FindSystemConfigService,
                private documentTypes: DocumentTypes,
                private picturesPermission: PicturesPermissionService) {
    }

    async ngOnInit() {
        this.configuration = this.configurationService.getConfiguration();
        if (!this.editItem && this.document.documentType === this.documentTypes.CONTRACT && !this.configuration.offLineMode) {
            await this.loadingOverlaySpinner();
            await this.fetchEquipment(null);
        }
        this.mobileConfiguration = this.configurationService.getMobileConfiguration();
        this.overbookingAllowed = this.findSysConfigService.findSystemSettingByNumber(320);
        this.overrideDescriptionAllowed = this.findSysConfigService.findSystemSettingByNumber(323);
        this.formatLastUpdateDate();
        this.populateDepartments();
        this.pdescAccessories = this.lokiJs.getCollection('haccess').chain().data();
        this.pluAccessories = this.lokiJs.getCollection('saccess').chain().data();
        this.initializeDates();

        // Checks if the modal is called in edition mode and assigns the detailline to the current equipment.
        if (this.editItem) {
            this.equipment = JSON.parse(JSON.stringify(this.detailLine));
            this.equipQty = this.detailLine.qty;
            this.setEquipment(this.equipment);
            return;
        } else {
            this.equipment = new DetaillineDTOModel();
        }
        console.log(this.detailLine);

        // Defines the initial state of the screen
        if (this.configuration.startEquipSelectedFromAllItems || this.document.scheduledDate === '1899-01-01 00:00:000' || this.document.documentType === this.documentTypes.BREAKDOWN_COLLECTION ) {
            this.showAll();
        } else {
            this.level = 1;
        }

        if (!this.editItem && this.document.documentType === this.documentTypes.CONTRACT && !this.configuration.offLineMode) {
            await this.loadingOverlay.dismiss();
        }
    }

    initializeDates() {
        if (this.isPdescPresent()) {
            this.fromDate = this.document.detailLines[0].fromDate;
            this.toDate = this.document.detailLines[0].toDate;
        } else {
            this.fromDate = this.document.scheduledDate;
            if (this.configuration.standardReturnTime) {
                this.toDate = this.formDate(this.document.scheduledDate, this.configuration.standardReturnTime);
            } else {
                this.toDate = this.document.scheduledDate;
            }
        }
    }

    async loadingOverlaySpinner() {
        await this.loadingController.create({
            message: 'Loading...',
            translucent: true,
            cssClass: 'custom-class custom-loading',
            spinner: 'bubbles'
        }).then((overlay) => {
            this.loadingOverlay = overlay;
            this.loadingOverlay.present();
        });
    }

    cancelModal() {
        if (this.editItem || this.configuration.startEquipSelectedFromAllItems ||  this.document.scheduledDate === '1899-01-01 00:00:000'
        || this.document.documentType === this.documentTypes.BREAKDOWN_COLLECTION ) {
            this.modalController.dismiss();
            return;
        }
        if (this.level > 1) {
            this.level--;
            if (this.level === 3 &&
                !(this.equipList)) {
                this.level--;
            }
            if (this.level === 2 &&
                !(this.groupList)) {
                this.level--;
            }
        } else {
            this.modalController.dismiss();
        }
    }

    pickColor(i: number) {
        if (i >= this.randomColors.colors.length) {
            i = i - this.randomColors.colors.length;
        }
        return this.randomColors.colors[i];
    }

    async populateDepartments() {
        this.deptList = await this.lokiJs.getCollection('hireDept').chain().simplesort('descr').data();
    }

    async refineToGroup(d: any) {
        this.level++;
        this.groupList = await this.lokiJs.getCollection('hireDeptGroup').chain().find({'hireDept': d.nsuk}).simplesort('descr').data();
    }

    async refineToProd(g: any) {
        this.level++;
        if (this.document.documentType !== this.documentTypes.CONTRACT
            && this.document.documentType !== this.documentTypes.SERVICEJOB
            && this.document.documentType !== this.documentTypes.CUSTOMERREPAIR
            && this.document.documentType !== this.documentTypes.STOCKING) {
            this.equipList = await this.lokiJs.getCollection('equipmentdistinctpdesc')
                .chain().find({'group': g.nsuk}).simplesort('description').data();
        } else {
            this.equipList = await this.lokiJs.getCollection('equipment')
                .chain().find({'group': g.nsuk, stat: {'$ne': [7, 9]}}).simplesort('description').data();
        }

        console.log(this.equipList);
    }

    showAll() {
        this.level = 3;
        if (this.document.documentType === this.documentTypes.ORDER || this.document.documentType === this.documentTypes.QUOTATION) {
            this.equipList = this.lokiJs.getCollection('equipmentdistinctpdesc').chain()
                .simplesort('description').data();
        } else if (this.document.documentType !== this.documentTypes.SERVICEJOB  && this.document.documentType !== this.documentTypes.CUSTOMERREPAIR) {
            // If health care is in use we must select from the current location
            if (this.mobileConfiguration && this.mobileConfiguration.mobilehireHealthCareInUse === 1) {
                this.equipList = this.lokiJs.getCollection('equipment')
                    .chain()
                    .find({$and: [{stat: {'$ne': [7, 9]}}, {location: this.configuration.selectedDepot}]})
                    .simplesort('description')
                    .data();
            } else {
                this.equipList = this.lokiJs.getCollection('equipment')
                    .chain().find({stat: {'$ne': [7, 9]}}).simplesort('description').data();
            }
        } else if (this.document.documentType === this.documentTypes.SERVICEJOB  || this.document.documentType === this.documentTypes.CUSTOMERREPAIR) {
            this.equipList = this.lokiJs.getCollection('equipment')
                .chain().find({typ: 'S', stat: {'$ne': null}}).simplesort('description').data();
        }
    }

    async setEquipment(e: DetaillineDTOModel) {
        if( this.document.documentType === this.documentTypes.BREAKDOWN_COLLECTION){
            this.insertReplacementItemIntoDocument(e);

            this.modalController.dismiss(e);
            return;
        }

        if(this.document.scheduledDate === '1899-01-01 00:00:000'){  // 
            this.modalController.dismiss(e);
            return;
        }


        if (this.document.documentType === this.documentTypes.SERVICEJOB || this.document.documentType === this.documentTypes.CUSTOMERSERVICE
             ||  (  this.document.documentType === this.documentTypes.CUSTOMERREPAIR && this.replacementItem !== true ) ) {
            this.modalController.dismiss(e);
            return;
        }
        console.log(e);
        this.queryText = '';
        this.level = 4;
       
        

        this.equipment = JSON.parse(JSON.stringify(e));

        // If the is being edited there's no need to check the neither discount nor the price again
        if (!this.editItem || this.document.documentType === this.documentTypes.SIGNDOCUMENT) {
            this.findEquipmentPriceService.getPrice(this.equipment, this.document.customer).then(res => {
                console.log(res);
                res.filter(equip => {
                    console.log(equip);
                    if (equip.pdesc === this.equipment.pdesc) {
                        this.findEquipmentPriceService.isDiscountable(equip.tender).then(result => {
                            console.log(result);
                            if (result === 1) {
                                this.discount = this.document.customer.hireDisc;
                            } else {
                                this.discount = 0;
                            }
                        });
                        this.weeklyRate = equip.week;
                        this.chargeLine = this.findEquipmentPriceService.addChargeLine(equip);
                        this.equipmentDescription = this.equipment.description;
                    } else {
                        this.discount = 0;
                    }
                });
            });
        } else {
            this.setEditValues();
        }
        this.calculatePrice();
    }

    insertReplacementItemIntoDocument(line: DetaillineDTOModel) {
        const tempLine = JSON.parse(JSON.stringify(line)) as DetaillineDTOModel;
        tempLine.overrideDescriptionNote = tempLine.description;
        tempLine.qty = (tempLine.qty && tempLine.qty > 0) ? tempLine.qty : 1;
        const resDate = new Date();
        tempLine.fromDate = resDate.toISOString();
        tempLine.toDate = resDate.toISOString();
        tempLine.weeklyRate = 0;
        
        delete tempLine.isChecked;
        this.document.replacementItem = tempLine;
    }

    addEquipment() {
        if (this.equipment.typ === 'S') {
            this.equipQty = 1;
        }
        if (!(this.equipQty) || this.equipQty <= 0) {
            this.generalServices.createToast('Quantity not valid');
            return;
        }

        if (this.checkDates()) {
            this.generalServices.createToast('Invalid Dates!');
            return; 
        }

        if (!this.editItem) {
            this.accessoriesTemp = [];
            this.accessoriesTemp = this.pdescAccessories.filter(acc => {
                // This will check if the Pdesc matches the package and
                // will add the equip only if it is not in the package already
                return acc.packagePdesc === this.equipment.pdesc && acc.packagePdesc !== acc.pdesc;
            });
            this.pluAccessories.filter(acc => {
                if (acc.packagePdesc === this.equipment.pdesc) {
                    this.accessoriesTemp.push(acc);
                }
            });

            console.log(this.accessoriesTemp);

            if (this.accessoriesTemp.length > 0) {
                console.log(this.equipment);
                this.addAccessories();
            }
        }

        if (this.editItem) {
            for (const equip of this.document.detailLines) {
                if (equip.pdesc === this.equipment.pdesc) {
                    this.setEquipDetails();
                    this.modalController.dismiss(this.document.detailLines);
                    this.equipment = new DetaillineDTOModel();
                    // It'll return once if there's a match the detailLine is being edited.
                    return;
                }
            }
        }
        this.setEquipDetails();
        console.log('Comment', this.equipment);
        this.document.detailLines.push(this.equipment);
        if (this.accessoriesTemp && this.accessoriesTemp.length <= 0) {
            this.generalServices.createToast('Equipment added to the document');
        }
        if (this.mobileConfiguration.mobilehireHealthCareInUse === 1 || this.replacementItem === true ) {
            this.modalController.dismiss();
            return;
        }
        if (this.configuration.startEquipSelectedFromAllItems  ) {
            this.showAll();
        } else {
            this.level = 1;
            this.populateDepartments();
        }
    }

    async addAccessories() {
        const modal = await this.modalController.create({
            component: AddAccessoriesPage,
            cssClass: 'modal-fullscreen',
            backdropDismiss: false,
            componentProps: {
                document: this.document,
                accessories: this.accessoriesTemp,
                package: this.equipment.packageName,
                equipment: this.equipment

            }
        });

        modal.onDidDismiss().then((dataReturned) => {
            // this.modalController.dismiss(this.document.detailLines);
        });

        return await modal.present();
    }

    async selectDate(type: number) {
        // Type: 1 for fromDate; 2 for toDate.
        let date = null;
        if (type === 1) {
            date = this.fromDate;
        } else if (type === 2) {
            date = this.toDate;
        }

        const alert = await this.alertController.create({
            header: 'Select Date',
            backdropDismiss: false,
            inputs: [
                {
                    name: 'date',
                    type: 'date',
                    value: this.generateDate(date)
                },
                {
                    name: 'time',
                    type: 'time',
                    value: this.generateTime(date, type)
                }
            ],
            buttons: [
                {
                    text: 'Cancel',
                    role: 'cancel',
                    cssClass: 'secondary',
                    handler: () => {
                        console.log('Confirm Cancel');
                    }
                }, {
                    text: 'Ok',
                    handler: data => {
                        console.log(data);
                        if (type === 1) {
                            this.fromDate = this.formDate(data.date, data.time);
                            this.checkDateConsistency(1);
                        } else if (type === 2) {
                            this.toDate = this.formDate(data.date, data.time);
                            this.checkDateConsistency(2);
                        }
                    }
                }
            ]
        });
        await alert.present();
    }

    formDate(date: string, time: string) {
        const year = date.substr(0, 4);
        const month = date.substr(5, 2);
        const day = date.substr(8, 2);
        const hour = time.substr(0, 2);
        const minute = time.substr(3, 2);

        const resDate = new Date();
        resDate.setFullYear(+year, +month - 1, +day);
        resDate.setHours(+hour, +minute);
        return resDate.toISOString();
    }




    generateDate(date: string) {
        return date.substr(0, 10);
    }

    generateTime(time: string, type: number) {
        if (type === 1) {
            return this.configuration.standardContractTime ?
                this.configuration.standardContractTime : time.substr(11, 2) + ':' + time.substr(14, 2);
        } else if (type === 2) {
            return this.configuration.standardReturnTime ?
                this.configuration.standardReturnTime : time.substr(11, 2) + ':' + time.substr(14, 2);
        } else {
            return time.substr(11, 2) + ':' + time.substr(14, 2);
        }
    }

    checkDateConsistency(index: number) {
        if (index === 1) {
            if (this.fromDate !== this.document.scheduledDate) {
                this.document.scheduledDate = this.fromDate;
            }
            if (this.toDate < this.document.scheduledDate) {
                this.toDate = this.document.scheduledDate;
            }
        }

        if (index === 2) {
            if (this.toDate < this.document.scheduledDate) {
                this.toDate = this.document.scheduledDate;
            }
        }
    }

    setEquipDetails() {
        this.equipment.comment = this.comment;
        this.equipment.chargeLine = this.chargeLine;
        this.equipment.weeklyRate = this.weeklyRate;
        this.equipment.chargeLine.week = this.weeklyRate;
        this.equipment.discount = this.discount;
        this.equipment.total = this.total;
        this.equipment.fromDate = this.fromDate;
        this.equipment.toDate = this.toDate;
        this.equipment.qty = this.equipQty;
        this.equipment.overrideDescriptionNote = this.equipmentDescription;
        this.equipment.location = this.document.location;
    }

    setEditValues() {
        this.comment = this.equipment.comment;
        this.weeklyRate = this.equipment.weeklyRate;
        this.discount = this.equipment.discount;
        this.total = this.equipment.total;
        this.fromDate = this.equipment.fromDate;
        this.toDate = this.equipment.toDate;
        this.equipQty = this.equipment.qty;
        this.chargeLine = this.equipment.chargeLine;
        this.equipmentDescription = this.equipment.overrideDescriptionNote;
    }

    setDiscount() {
        this.equipment.discount = 0;
    }

    calculatePrice() {
        this.total = this.weeklyRate - (this.weeklyRate * this.discount / 100);
    }

    checkDates() {
        return this.fromDate > this.toDate;
    }

    async scanCode() {
        await this.picturesPermission.checkPermissions();

        const modal = await this.modalController.create({
            component: BarcodescannerComponent,
            cssClass: 'modal-fullscreen',
            componentProps: {
                'document': this.document
            }
        });

        modal.onDidDismiss().then((dataReturned) => {
            if (dataReturned.data) {
                console.log('Data REturned !!');
                console.log(dataReturned);
                this.setEquipment(dataReturned.data);
            }
        });
        return await modal.present();
    }

    async fetchEquipment(event) {
        try {
            await this.testConnection.pingServer();
            await this.refreshDB.refreshPlantHireResource();
            if (event) {
                await event.target.complete();
            }
            this.configuration = await this.configurationService.getConfiguration();
            await this.formatLastUpdateDate();
            if (this.level === 3) {
                this.showAll();
            } else {
                this.deptList = await this.lokiJs.getCollection('hireDept').chain().simplesort('descr').data();
                this.groupList = await this.lokiJs.getCollection('hireDeptGroup').chain().simplesort('descr').data();
            }
        } catch (e) {
            await this.generalServices.createToast('It was not possible to update the equipment', 2000);
            if (event) {
                await event.target.complete();
            }
        }

    }

    private isPdescPresent() {
        if (this.document.detailLines.length <= 0) {
            return false;
        }
        for (const line of this.document.detailLines) {
            if (line.pdesc) {
                return true;
            }
        }
        return false;
    }

    async checkPlantStatus(e: DetaillineDTOModel) {
        if (e.stat === 1 || e.stat === 200 || this.document.documentType !== 1 || e.typ === 'M' || e.typ === 'P') {
            this.setEquipment(e);
        } else if (this.overbookingAllowed.set === 1) {
            const alert = await this.alertController.create({
                header: 'Overbooking',
                message: 'This plant Item is marked as on hire,\n do you wish to overbook it?',
                backdropDismiss: false,
                buttons: [
                    {
                        text: 'Cancel',
                        role: 'cancel',
                        cssClass: 'secondary',
                        handler: () => {
                            console.log('Canceled Overbooking');
                        }
                    }, {
                        text: 'Ok',
                        handler: () => {
                            this.setEquipment(e);
                        }
                    }
                ]
            });
            await alert.present();
        } else {
            this.generalServices.createToast('This item is not available');
        }
    }

    private formatLastUpdateDate() {
        this.lastUpdate = this.generateDateFromTimestamp.formatLastUpdateDate(this.configuration.equipmentDateTime);
    }
}
